export const CLOSE = 'CLOSE' //Grey
export const SUBMIT = 'SUBMIT' //Blue
export const CANCEL = 'CANCEL'
export const SECONDARY = 'SECONDARY' //secondary
export const VOTE = 'VOTE' //secondary
export const WARNING = 'WARNING' //secondary
export const INFO = 'INFO' //sky
